/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import useJournalEntryService from 'domain/finance/journalEntry/useJournalEntryService';
import { useJournalEntryId, useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import CreateLedgerBreadcrumbs from 'domain/finance/journalEntry/createupdate/Create/Breadcrumbs';
import JournalEntryForm from 'domain/finance/journalEntry/createupdate/JournalEntryForm';
import { useSearchParameters } from 'framework/routing';

const CreateLedgerPage = () => {
  const { create, getById, getValidationSchema } = useJournalEntryService();
  const { getListUrl } = useJournalEntryUrl();
  const id = useJournalEntryId();
  let getDataFunc;
  const { accountId, currency } = useSearchParameters();

  if (id) {
    getDataFunc = () => getById(id);
  }

  return (
    <CreateForm
      submitFormFunc={create}
      getDataFunc={getDataFunc}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Journal Entry has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        totals: 0,
        transfers: [{ accountId, currency }, {}],
      }}
    >
      <CreatePageLayout breadcrumbs={<CreateLedgerBreadcrumbs />} title="Create: Journal Entry">
        <JournalEntryForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateLedgerPage;
